import onReady from '@/scripts/modules/on-ready';

onReady( () => {
	function styleSubmitButton() {
		const submitBtn = document.getElementById( 'wp-submit' );

		if ( submitBtn ) {
			const btnText = submitBtn.getAttribute( 'value' );
			const btnElement = document.createElement( 'button' );
			btnElement.setAttribute( 'type', 'submit' );
			btnElement.setAttribute( 'name', 'wp-submit' );
			btnElement.className = 'btn--plain';
			const btnInnerElement = document.createElement( 'span' );
			btnInnerElement.textContent = btnText;
			const firstArrow = document.createElement( 'i' );
			firstArrow.className = 'vtx-icon vtx-icon-down_arrow first-arrow';
			const secondArrow = document.createElement( 'i' );
			secondArrow.className = 'vtx-icon vtx-icon-down_arrow second-arrow';

			btnElement.appendChild( firstArrow );
			btnElement.appendChild( btnInnerElement );
			btnElement.appendChild( secondArrow );
			submitBtn.after( btnElement );
			submitBtn.remove();
		}
	}

	function styleRememberMe() {
		const checkbox = document.getElementById( 'rememberme' );
		const checkboxWrapper = document.querySelector( '.login-remember' );

		if ( checkbox && checkboxWrapper ) {
			if ( checkbox.checked ) {
				checkboxWrapper.classList.add( 'checked' );
			} else {
				checkboxWrapper.classList.remove( 'checked' );
			}

			checkbox.addEventListener( 'change', () => {
				if ( checkbox.checked ) {
					checkboxWrapper.classList.add( 'checked' );
				} else {
					checkboxWrapper.classList.remove( 'checked' );
				}
			} );
		}
	}

	styleRememberMe();
	styleSubmitButton();
} );
